<template>
    <div class="e-stats__items">
        <div
            v-for="(item, index) in items"
            :key="index"
            class="e-stats__item"
        >
            <div class="e-stats__figure">
                
                <span
                    class="e-stats__figure-number"
                    :data-end="item.figure"
                    ref="numbers"
                ></span>
            
                <span class="e-stats__figure-icon" ref="icons">
                    <slot name="icon" :item="item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M24 9h-9v-9h-6v9h-9v6h9v9h6v-9h9z"/></svg>
                    </slot>
                </span>

            </div>

            <div class="e-stats__content">{{ item.content }}</div>

        </div>

  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
    name: "StatsCounter",
    props: {
        items: {
            type: Array,
            required: true,
            // Each item: { figure: Number, content: String }
        }
    },
    mounted() {
        this.setupCounters();
    },
    methods: {
        setupCounters() {
            const numbers = this.$refs.numbers;
            const icons = this.$refs.icons;

            // For each figure element
            numbers.forEach((numberEl, index) => {
                const iconEl = icons[index];
                const end = parseInt(numberEl.dataset.end);

                // Use ScrollTrigger
                ScrollTrigger.create({
                    trigger: numberEl.parentElement, // .e-stats__figure
                    start: "top 80%",
                    onEnter: () => this.animateCounter(numberEl, iconEl, end),
                    onEnterBack: () => this.animateCounter(numberEl, iconEl, end)
                });
            });
        },

        animateCounter(numberEl, iconEl, end) {
            // Reset
            numberEl.innerHTML = "";
            gsap.set(iconEl, { opacity: 0 });

            // Animate counter
            const count = { value: 0 };
            gsap.to(count, {
                value: end,
                duration: 2,
                roundProps: "value",
                onUpdate: () => {
                    const formatted = count.value
                        .toString()
                        .split("")
                        .map(d => `<span>${d}</span>`)
                        .join("");
                    numberEl.innerHTML = formatted;
                },
                onComplete: () => {
                    gsap.to(iconEl, { opacity: 1, duration: 0.3 });
                }
            });
        }
    }
};
</script>
